import React from "react";
import { View, StyleSheet } from "react-native";
import { useNavigation, type NavigationProp } from "@react-navigation/native";
import { Calendar } from "lucide-react-native";
import {
  QuestionLayout,
  CounterInput,
} from "@src/packages/medical-history/components";
import { useTranslations } from "@src/packages/i18n";
import { useMenstrualHealth } from "../MenstrualHealthContext";
import { buildMenstrualHealthNavigationStack } from "../buildMenstrualHealthNavigationStack";
import type { MenstrualHealthStackParamList } from "../MenstrualHealthNavigator";

export function AgeAtFirstPeriodScreen() {
  const t = useTranslations();
  const { state, updateState, save } = useMenstrualHealth();
  const navigation =
    useNavigation<NavigationProp<MenstrualHealthStackParamList>>();

  const value = state.ageAtFirstPeriod;

  const handleSave = async () => {
    await save();
    const stack = buildMenstrualHealthNavigationStack(state);
    const currentIdx = stack.indexOf("AgeAtFirstPeriod");
    const nextRoute = stack[currentIdx + 1];
    if (nextRoute) {
      navigation.navigate(nextRoute);
    }
  };

  return (
    <QuestionLayout
      title={t("med_history.gynae.menstrual_health.age_first_period_title")}
      onBack={() => navigation.goBack()}
      onSave={handleSave}
      saveDisabled={state.ageAtFirstPeriod === null}
      hideSaveButton={state.ageAtFirstPeriod === null}
      saveLabel={t("med_history.gynae.menstrual_health.continue")}
    >
      <View style={styles.container}>
        <CounterInput
          label={t("med_history.gynae.menstrual_health.age_label")}
          icon={Calendar}
          value={value}
          min={5}
          max={25}
          onIncrement={() =>
            updateState({
              ageAtFirstPeriod: value === null ? 5 : Math.min(value + 1, 25),
            })
          }
          onDecrement={() =>
            updateState({
              ageAtFirstPeriod: value === null ? 5 : Math.max(value - 1, 5),
            })
          }
        />
      </View>
    </QuestionLayout>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    marginBottom: 40,
  },
});
